"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvidersWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const auth_1 = require("@completeanatomy/auth");
const bridge_1 = require("@completeanatomy/bridge");
const ui_1 = require("@completeanatomy/ui");
const user_1 = require("@completeanatomy/user");
const GlobalStyles_1 = require("../../GlobalStyles");
const CircleBackgroundAnimation_1 = require("../../context/CircleBackgroundAnimation");
const FormData_1 = require("../../context/FormData");
const Progress_1 = require("../../context/Progress");
/**
 * Wrapper with all providers
 */
function ProvidersWrapper({ children, }) {
    return (
    // @ts-ignore
    (0, jsx_runtime_1.jsxs)(ui_1.ThemeProvider, { theme: ui_1.darkTheme, "data-e2e": 'ProvidersWrapper_ThemeProvider', children: [(0, jsx_runtime_1.jsx)(GlobalStyles_1.GlobalStyles, { "data-e2e": 'ProvidersWrapper_GlobalStyles' }), (0, jsx_runtime_1.jsx)(bridge_1.BridgeProvider, { "data-e2e": 'ProvidersWrapper_BridgeProvider', children: (0, jsx_runtime_1.jsx)(auth_1.AuthProvider, { "data-e2e": 'ProvidersWrapper_AuthProvider', children: (0, jsx_runtime_1.jsx)(user_1.UserServiceProvider, { "data-e2e": 'ProvidersWrapper_UserServiceProvider', children: (0, jsx_runtime_1.jsx)(Progress_1.ProgressProvider, { "data-e2e": 'ProvidersWrapper_ProgressProvider', children: (0, jsx_runtime_1.jsx)(CircleBackgroundAnimation_1.CircleBackgroundAnimationProvider, { "data-e2e": 'ProvidersWrapper_CircleBackgroundAnimationProvider', children: (0, jsx_runtime_1.jsx)(FormData_1.FormDataProvider, { "data-e2e": 'ProvidersWrapper_FormDataProvider', children: children }) }) }) }) }) })] }));
}
exports.ProvidersWrapper = ProvidersWrapper;
